<template>
  <div id="app">
    <tab-bar v-if="$route.meta.tabbarShow">
      <tab-bar-item link="/home" activeColor="#A471AA">
        <img slot="item-icon" src="./assets/index.png" alt="">
        <img slot="item-icon-active" src="./assets/index1.png" alt="">
        <div slot="item-text">首页</div>
      </tab-bar-item>
      <tab-bar-item link="/my" activeColor="#A471AA">
        <img slot="item-icon" src="./assets/my.png" alt="">
        <img slot="item-icon-active" src="./assets/my1.png" alt="">
        <div slot="item-text">我的</div>
      </tab-bar-item>
    </tab-bar>
    <router-view></router-view>
  </div>
</template>

<script>

import tabBar from "./component/tabbar";
import TabBarItem from "./component/tabbarItem";
export default {
  name: 'App',
  components:{
    tabBar,
    TabBarItem
  }
}
</script>

<style>
#app{
  height: 100%;
}
.van-nav-bar .van-icon{
  color: #A471AA !important;
}
.van-nav-bar__text {
  color: #A471AA !important;
}
@supports (bottom: env(safe-area-inset-bottom)){
  #app {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

</style>
